import { TodoItem } from "types/dict";

export interface PaymentProps {
  payment_request_id: number;
  user_id: number;
  user_name: string;
  creator_name: string;
  location_id: number;
  choosen_location: string;
  company_id: number;
  company_name: string;
  department_id: number;
  department_name: string;
  template_id: number;
  template_name: string;
  project: string;
  year: number;
  title: string;
  contragent_id: number;
  contragent: string;
  document_request_id: number;
  dogovor: string;
  total_sum: number;
  vid_oplaty: string;
  budget_summa: number;
  ostatok_budgeta: number;
  opisanie_rasxoda: string;
  first_comment: string;
  additional_info: string;
  request_date: string;
  status: number;
  pending_approver_id: number;
  pending_approver_name: string;
  approver_name: string;
  pending_action_type: string;
  file_path: string;
  todo_items: TodoItem[];
}

export interface PaymentListResponse {
  [key: number]: {
    data: PaymentProps[];
    total_count: number;
  };
}

export const PaymentListDefault: PaymentListResponse = {
  0: {
    data: [],
    total_count: 0,
  },
};

export interface PaymentTableResponse {
  data: PaymentProps[];
  total_count: number;
}

export const PaymentTableDefault: PaymentTableResponse = {
  data: [],
  total_count: 0,
};

export interface PaymentFilters {
  hash_pw: string | undefined;
  search: string | undefined;
  from_date: string | undefined;
  to_date: string | undefined;
  locations: string[] | undefined;
  template_name: string | undefined;
  contragent_id: number | undefined;
  project: string | undefined;
  title: string | undefined;
  dogovor: string | undefined;
  total_sum_from: number | undefined;
  total_sum_to: number | undefined;
  creator_name: string | undefined;
  approver_name: string | undefined;
  status: number[] | undefined;
  sort_by: string[] | undefined;
  limit: number | undefined;
  offset: number | undefined;
}

export const PaymentFiltersDefault: PaymentFilters = {
  hash_pw: undefined,
  search: undefined,
  from_date: undefined,
  to_date: undefined,
  locations: undefined,
  template_name: undefined,
  contragent_id: undefined,
  project: undefined,
  title: undefined,
  dogovor: undefined,
  total_sum_from: undefined,
  total_sum_to: undefined,
  creator_name: undefined,
  approver_name: undefined,
  status: undefined,
  sort_by: undefined,
  limit: undefined,
  offset: undefined,
};
